import { render, staticRenderFns } from "./TicketsAdmin.vue?vue&type=template&id=5d842730&scoped=true&"
import script from "./TicketsAdmin.vue?vue&type=script&lang=js&"
export * from "./TicketsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TicketsAdmin.vue?vue&type=style&index=0&id=5d842730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d842730",
  null
  
)

export default component.exports